<div class="us-reward-token-info">
    <div class="acca-boost-parlay-title">{{ sitecore.accaBoost.ParlayBoost }}</div>
    <bs-acca-boost-ladder-us-info-sports [pickCount]="pickCount" [notification]="notification"> </bs-acca-boost-ladder-us-info-sports>
    <div class="acca-boost-parlay-legs-info">
        <div class="acca-boost-parlay-info-heading">{{ sitecore.accaBoost.BoostIncreasesPercentageInfo }}</div>
        <bs-acca-boost-ladder-us-info-legs-list [pickCount]="pickCount" [notification]="notification"> </bs-acca-boost-ladder-us-info-legs-list>
    </div>
</div>
<div class="acca-boost-parlay-done">
    <div class="acca-boost-parlay-button" (click)="closeClick()">{{ sitecore.accaBoost.Done }}</div>
</div>
